import {Branding} from '../Branding.types'

import LogoHIQ from './icons/Logo-HIQ.svg'

export const hubHiqAu: Branding = {
  nationalBrandName: 'High Quality Group',
  nationalLogoUrl: LogoHIQ,
  nationalLogoTitle: 'High Quality Group',
  nationalUrl: 'https://hub.highqualityconcrete.com.au/',
  contactEmail: 'digital@highqualityconcrete.com.au',
  contactEmailSubject: 'Mail from High Quality Group',
  safetyDataSheetLink: 'https://www.heidelbergmaterials.us/resources/safety-data-sheets',
  pageTitle: 'High Quality Group',
  country: 'AU',
  termsAndConditionsOfSale: 'https://highqualityconcrete.com.au/wp-content/uploads/2026/03/HQ-TCs-of-Sale-1-April-2026.pdf'
}
